module.exports = __webpack_public_path__ + "img/dexters_cell_phone_belt.bb3e29c4.jpg";